import React, { useEffect, useRef } from "react";
import styles from "./styles.module.css";
import clsx from "clsx";
import { getWidth } from "../../utils/relativeSizes";
import Header from "../../components/Header";
import { useTranslation } from "react-i18next";
import { getPartnerId } from "../../utils/helpers/common";
import { FbPixelEvent_PageView } from "../../utils/FbPixel/fbPixel";
import { FACEBOOK } from "../../utils/helpers/constants";
interface IHowToPlay {

}
const HowToPlay: React.FC<IHowToPlay> = () => {
  const video_en = "https://assets.zupee.com/ludosupreme.com/assets/36_moves_6_tokens_htp_english.mp4"
  const video_hi = "https://assets.zupee.com/ludosupreme.com/assets/Nx36moves/36_moves_6_tokens_htp_hindi.mp4";
  const language = localStorage.getItem('language') || 'en';
  const { t } = useTranslation();
  const hasTrackedRef = useRef(false);
  
  useEffect(() => {
    if (getPartnerId() === FACEBOOK && !hasTrackedRef.current) {
      hasTrackedRef.current = true;
      FbPixelEvent_PageView();
    }
  }, []);
  return (
    <>
      <Header pageTitle={t("howToPlay")} />
      <div className={clsx(styles.howToPlayVideo, "pageWrapper")}>
        <video
          controls
          autoPlay
          className={clsx(styles.videoIframe)}
        >
          <source src={language === 'en' ? video_en : video_hi} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    </>
  )

}
export default HowToPlay;